@if (model) {
    @if (model.fixtures.length) {
        <ms-day-of-race-lobby [dayOfRace]="model" [filter]="day" [sportId]="sportId" />
    }
    @if (!model.fixtures.length) {
        <ms-greyhounds-error-breadcrumb>
            <ms-error item-header [links]="false" [message]="errorMessage" [severity]="'info'" />
        </ms-greyhounds-error-breadcrumb>
    }
}
